import * as R from 'ramda'

import * as types from './types'
import { NotificationLevel } from './levels'

/**
 * Notification.
 *
 * @typedef {Object} Notification
 * @property {?string} [context] Optional notification context (e.g. `dev` or
 * `commercial`); used to display notifications conditionally.
 * @property {Level} level Notification severity level; used to style and
 * display notifications conditionally.
 * @property {string} message Translation key
 * @property {?Object} [variables] Translation variables
 */

/**
 * Adds notification.
 *
 * @param {Notification} payload
 * @returns {Object} Redux action
 */
export function add(payload) {
  if (
    R.not(R.contains(payload.level, R.values(NotificationLevel))) ||
    R.isNil(payload.message)
  ) {
    const levels = R.join(', ', R.values(NotificationLevel))
    // eslint-disable-next-line no-console
    console.error(`'level' must be one of: ${levels}.`)
    return { type: 'NOOP' }
  }

  if (typeof payload.message !== 'string') {
    // eslint-disable-next-line no-console
    console.error(`'message' must be a string.`)
    return { type: 'NOOP' }
  }

  if (R.isEmpty(payload.message)) {
    // eslint-disable-next-line no-console
    console.error(`'message' is required in payload.`)
    return { type: 'NOOP' }
  }

  return {
    type: types.ADDED,
    payload,
  }
}

/**
 * Removes notification.
 *
 * @param {number} index Notification’s index
 * @returns {Object} Redux action
 */
export function dismiss(index) {
  return {
    type: types.DISMISSED,
    payload: index,
  }
}

/**
 * Removes all notifications.
 *
 * @returns {Object} Redux action
 */
export function dismissAll() {
  return {
    type: types.DISMISSED_ALL,
  }
}
